<template>
  <div class="business-search-detail">
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 25px;padding-top: 25px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/businessSearch' }"
            >商机线索</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="titleInfo.titleForm === 'businessSearchList'"
            :to="{ path: '/businessSearchList' }"
          >
            商机列表
          </el-breadcrumb-item>
          <el-breadcrumb-item>商机详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-top-box">
        <el-card>
          <div>
            <div class="overflow-ellipsis top-title">
              {{ detailInfo.title }}
            </div>
            <div class="top-info">
              <el-row :gutter="20">
                <el-col :span="12"
                  >发布日期：{{ detailInfo.publishDate }}</el-col
                >
                <el-col :span="8">查看次数：{{ detailInfo.pageViews }}</el-col>
                <el-col :span="4" class="star-box">
                  收藏：
                  <i
                    class="star-icon"
                    :class="
                      detailInfo.isFav
                        ? 'star-select el-icon-star-on'
                        : 'star-normal el-icon-star-off'
                    "
                    @click="onClickFav"
                  />
                </el-col>
              </el-row>
            </div>
            <div class="top-line" />
            <table border="1" style="border-collapse:collapse;width: 100%;">
              <tr>
                <td width="100" class="table-title">发布时间</td>
                <td width="200" class="table-value">
                  {{ detailInfo.publishDate }}
                </td>
                <td width="100" class="table-title">项目编号</td>
                <td width="200" class="table-value">
                  {{ detailInfo.itermCode }}
                </td>
              </tr>
              <tr>
                <td width="100" class="table-title">招标预算</td>
                <td width="200" class="table-value">{{ detailInfo.money }}</td>
                <td width="100" class="table-title">资质要求</td>
                <td width="200" v-if="isLogin" class="table-value">
                  {{ detailInfo.aptitudeRequest }}
                </td>
                <td
                  width="200"
                  v-else
                  class="table-value table-login"
                  @click="onClickLogin"
                >
                  登录查看
                </td>
              </tr>
              <tr>
                <td width="100" class="table-title">招标单位</td>
                <td width="200" class="table-value">
                  {{ detailInfo.company }}
                </td>
                <td width="100" class="table-title">
                  联&nbsp;&nbsp;系&nbsp;&nbsp;人
                </td>
                <td width="200" v-if="isLogin" class="table-value">
                  {{ detailInfo.linkUser }}
                </td>
                <td
                  width="200"
                  v-else
                  class="table-value table-login"
                  @click="onClickLogin"
                >
                  登录查看
                </td>
              </tr>
            </table>

            <div class="summary-box">
              <div class="summary-title">
                <div class="title-icon" />
                <span class="title-text">招标简介</span>
              </div>
              <div v-html="detailInfo.summary"></div>
              <div class="summary-title">
                <div class="title-icon" />
                <span class="title-text">招标正文</span>
              </div>
              <div
                class="summary-mid-img"
                v-if="!isLogin"
                :style="{ backgroundImage: `url(${advBgUrl})` }"
                @click="onClickLogin"
              ></div>
              <div v-if="isLogin" v-html="detailInfo.content"></div>
              <div
                v-else
                class="summary-content-img"
                :style="{ backgroundImage: `url(${contentBgUrl})` }"
              ></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getDictionaryItem, getFrontItemDetail } from "../../utils/interface"
import { mapState } from "vuex"

export default {
  //   商机线索详情页
  name: "saasDetails",
  metaInfo: {
    title: "商机线索-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台商机线索提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},

  data() {
    return {
      curUuid: "",
      advBgUrl: "",
      contentBgUrl: require("../../assets/businessSearchDetail.png"),
      detailInfo: {},
      titleInfo: {
        titleName: "商机列表",
        titleForm: "businessSearchList",
      },
    }
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  created() {
    this.getParams()
    this.getOptionsData()
  },
  methods: {
    getParams() {
      this.curUuid = this.$route.params.uuid
      this.titleInfo.titleName = this.$route.query.titleName
      this.titleInfo.titleForm = this.$route.query.titleForm
      this.getDetailByUuid()
    },
    getDetailByUuid() {
      getFrontItemDetail(this.curUuid).then((res) => {
        this.detailInfo = res.data
      })
    },
    onClickFav() {
      this.detailInfo.isFav = 1 - this.detailInfo.isFav
      this.onClickLogin()
    },
    onClickLogin() {
      this.$router.push("/login")
    },
    getOptionsData() {
      getDictionaryItem({
        code: "SJXS-DETAIL-MEMBER-BACK",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.advBgUrl = res[0].value
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.business-search-detail {
  background: #f4f4f4;

  .overflow-ellipsis {
    //整体超出部分隐藏
    overflow: hidden;
    //文本超出部分以...形式展示，同第一行样式代码
    text-overflow: ellipsis;
    //display 块级元素展示
    display: -webkit-box;
    //设置文本行数为2行
    -webkit-line-clamp: 2;
    //设置文本行数为2行
    line-clamp: 2;
    //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
    -webkit-box-orient: vertical;
  }

  .detail-top-box {
    padding-bottom: 15px;

    .top-title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }

    .top-info {
      text-align: center;
      width: 50%;
      margin: 20px auto;
      font-size: 14px;
      color: #333333;
    }

    .top-line {
      width: 1200px;
      height: 1px;
      background-color: #039a9a;
      margin-bottom: 25px;
      transform: translateX(-21px);
    }

    table {
      border: 1px solid #d7d7d7;
      font-size: 14px;
      color: #333333;
    }

    table td {
      height: 30px;
      text-align: center;
    }

    .table-title {
      background-color: #eff7f7;
    }

    .table-value {
      text-align: left;
      padding-left: 15px;
    }

    .table-login {
      color: #019999;
      cursor: pointer;
      user-select: none;
    }

    .star-box {
      position: relative;

      .star-icon {
        position: absolute;
        color: #c2c2c2;
        cursor: pointer;
      }

      .star-select {
        color: #f7ba2a;
        font-size: 20px;
      }

      .star-normal {
        color: #c2c2c2;
        font-size: 18px;
      }
    }
  }

  .summary-box {
    .summary-title {
      display: flex;
      margin: 20px 0;
    }

    .title-icon {
      width: 3px;
      height: 18px;
      background: #019999;
      white-space: nowrap;
      margin-right: 8px;
      margin-top: 3px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .summary-mid-img {
      height: 80px;
      width: 1200px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      transform: translateX(-21px);
      transition: all 0.2s;
    }

    .summary-mid-img:hover {
      background-size: 110% 110%;
    }

    .summary-content-img {
      height: 559px;
      width: 1200px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      transform: translateX(-21px);
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessSearch/businessSearchDetails.vue